/**
 * Multi-Chart Layout Types
 * Based on TradingView's multi-chart layout system
 */

export type LayoutType = 
  | '1x1'  // Single chart
  | '2x1'  // Two charts side by side
  | '1x2'  // Two charts stacked
  | '2x2'  // Four charts in grid
  | '3x1'  // Three charts horizontal
  | '1x3'  // Three charts vertical
  | '3x2'  // Six charts (3 columns, 2 rows)
  | '2x3'  // Six charts (2 columns, 3 rows)
  | '4x1'  // Four charts horizontal
  | '1x4'; // Four charts vertical

export interface ChartPanelConfig {
  id: string;
  symbol: string;
  timeframe: string;
  width?: number;  // Percentage or pixels
  height?: number; // Percentage or pixels
}

export interface LayoutConfig {
  type: LayoutType;
  panels: ChartPanelConfig[];
  syncCrosshair?: boolean;  // Sync crosshair across charts
  syncTimeframe?: boolean;  // Sync timeframe changes
  syncSymbol?: boolean;     // Sync symbol changes
}

export interface LayoutTemplate {
  id: string;
  name: string;
  type: LayoutType;
  description: string;
  icon: string; // SVG path or component name
  rows: number;
  cols: number;
}

export const LAYOUT_TEMPLATES: LayoutTemplate[] = [
  {
    id: 'single',
    name: 'Single',
    type: '1x1',
    description: 'One chart',
    icon: 'single',
    rows: 1,
    cols: 1
  },
  {
    id: 'horizontal-2',
    name: 'Horizontal 2',
    type: '2x1',
    description: 'Two charts side by side',
    icon: 'horizontal-2',
    rows: 1,
    cols: 2
  },
  {
    id: 'vertical-2',
    name: 'Vertical 2',
    type: '1x2',
    description: 'Two charts stacked',
    icon: 'vertical-2',
    rows: 2,
    cols: 1
  },
  {
    id: 'grid-2x2',
    name: 'Grid 2×2',
    type: '2x2',
    description: 'Four charts in grid',
    icon: 'grid-2x2',
    rows: 2,
    cols: 2
  },
  {
    id: 'horizontal-3',
    name: 'Horizontal 3',
    type: '3x1',
    description: 'Three charts horizontal',
    icon: 'horizontal-3',
    rows: 1,
    cols: 3
  },
  {
    id: 'vertical-3',
    name: 'Vertical 3',
    type: '1x3',
    description: 'Three charts stacked',
    icon: 'vertical-3',
    rows: 3,
    cols: 1
  },
  {
    id: 'grid-3x2',
    name: 'Grid 3×2',
    type: '3x2',
    description: 'Six charts (3 cols, 2 rows)',
    icon: 'grid-3x2',
    rows: 2,
    cols: 3
  },
  {
    id: 'grid-2x3',
    name: 'Grid 2×3',
    type: '2x3',
    description: 'Six charts (2 cols, 3 rows)',
    icon: 'grid-2x3',
    rows: 3,
    cols: 2
  },
  {
    id: 'horizontal-4',
    name: 'Horizontal 4',
    type: '4x1',
    description: 'Four charts horizontal',
    icon: 'horizontal-4',
    rows: 1,
    cols: 4
  },
  {
    id: 'vertical-4',
    name: 'Vertical 4',
    type: '1x4',
    description: 'Four charts stacked',
    icon: 'vertical-4',
    rows: 4,
    cols: 1
  }
];
